// extracted by mini-css-extract-plugin
export default {"green":"CryptoAmount_green__r1l4b"};